document.addEventListener('DOMContentLoaded', () => {

  let isApplying = false;
  let parentObserver = null;
  let lastAppliedPrice = null;
  let lastAppliedSection = null;

  const EVENT_VARIANT_UPDATE = 'variant:update';
  const EVENT_QTY_UPDATE = 'quantity-selector:update';

  function getSectionForEvent(event) {
    if (event?.target instanceof HTMLElement) {
      return event.target.closest('.shopify-section, dialog') || document.body;
    }
    return document.body;
  }

  function getQty(scope) {
    const scoped = scope || document;
    const input =
      scoped.querySelector('quantity-selector-component input[ref="quantityInput"]') ||
      scoped.querySelector('input[name="quantity"]');

    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  /**
   * UPDATED PARSING LOGIC: Handles "5 - 9" or "15+" format
   * Column 0: Range (Min - Max)
   * Column 2: Price (Preis)
   */
  function getRules(scope) {
    const scoped = scope || document;
    // Updated selector for the new table ID
    const table = scoped.querySelector('#wcp_vd_table table');
    if (!table) return [];

    return Array.from(table.querySelectorAll('tbody tr')).filter(tr => tr.querySelector('td')).map(tr => {
      const rangeText = tr.children[0].innerText.trim(); // "5 - 9" or "15+"
      const priceText = tr.children[2].innerText.trim(); // "CHF 230.00"

      let min = 1;
      let max = Infinity;

      if (rangeText.includes('+')) {
        min = parseInt(rangeText, 10);
      } else if (rangeText.includes('-')) {
        const parts = rangeText.split('-');
        min = parseInt(parts[0], 10);
        max = parseInt(parts[1], 10);
      } else {
        min = parseInt(rangeText, 10);
      }

      return {
        min,
        max,
        price: priceText
      };
    });
  }

  function getPriceTargets(scope) {
    const scoped = scope || document;
    return [
      ...scoped.querySelectorAll('product-price div[ref="priceContainer"] .price'),
      ...scoped.querySelectorAll('.sticky-add-to-cart__price div[ref="priceContainer"] .price'),
      ...scoped.querySelectorAll('.price-item--regular') // Added common Dawn theme selector
    ];
  }

  function rememberBasePrice(targets) {
    targets.forEach(el => {
      if (!el.dataset.customBasePrice) {
        el.dataset.customBasePrice = el.innerHTML;
      }
    });
  }

  function restoreBasePrice(targets) {
    targets.forEach(el => {
      if (el.dataset.customBasePrice) {
        el.innerHTML = el.dataset.customBasePrice;
      }
      // Remove any injected compare-at-price spans
      const injected = el.parentElement?.querySelector('.compare-at-price-custom');
      if (injected) injected.remove();
    });
  }

  function applyPrice(scope) {
    if (isApplying) return;

    const targets = getPriceTargets(scope);
    if (!targets.length) return;

    const rules = getRules(scope);
    const qty = getQty(scope);

    // Find the rule where current quantity falls between min and max
    const rule = rules.find(r => qty >= r.min && qty <= r.max);
    
    if (!rule) {
      restoreBasePrice(targets);
      return;
    }

    if (rule.price === lastAppliedPrice && scope === lastAppliedSection) return;

    let applied = false;
    isApplying = true;

    rememberBasePrice(targets);

    targets.forEach(el => {
      const basePrice = el.dataset.customBasePrice;

      // Remove any previously injected compare-at-price span
      const existing = el.parentElement?.querySelector('.compare-at-price-custom');
      if (existing) existing.remove();

      // Insert original price as strikethrough compare-at-price before the price element
      if (basePrice) {
        const compareSpan = document.createElement('span');
        compareSpan.className = 'compare-at-price compare-at-price-custom';
        compareSpan.innerHTML = basePrice;
        el.parentElement.insertBefore(compareSpan, el);
      }

      el.innerHTML = rule.price;
      applied = true;
    });

    isApplying = false;

    if (applied) {
      lastAppliedPrice = rule.price;
      lastAppliedSection = scope;
    }
  }

  function watchVariantReRender(scope) {
    if (parentObserver) parentObserver.disconnect();

    const stableParent =
      scope?.querySelector('product-form') || document.querySelector('product-form') || document.body;

    parentObserver = new MutationObserver(() => {
      requestAnimationFrame(() => applyPrice(scope || document));
    });

    parentObserver.observe(stableParent, {
      childList: true,
      subtree: true
    });
  }

  /* --- Event Listeners --- */

  document.addEventListener('input', e => {
    if (e.target.matches('input[name="quantity"]')) {
      lastAppliedPrice = null;
      applyPrice(getSectionForEvent(e));
    }
  });

  document.addEventListener('click', e => {
    if (e.target.closest('[name="plus"]') || e.target.closest('[name="minus"]')) {
      lastAppliedPrice = null;
      applyPrice(getSectionForEvent(e));
    }
  });

  document.addEventListener('change', e => {
    if (e.target.matches('[name="id"]')) {
      lastAppliedPrice = null;
      const scope = getSectionForEvent(e);
      setTimeout(() => applyPrice(scope), 400);
    }
  });

  document.addEventListener(EVENT_QTY_UPDATE, e => {
    lastAppliedPrice = null;
    applyPrice(getSectionForEvent(e));
  });

  document.addEventListener(EVENT_VARIANT_UPDATE, e => {
    lastAppliedPrice = null;
    const scope = getSectionForEvent(e);
    watchVariantReRender(scope);
    setTimeout(() => applyPrice(scope), 0);
  });

  /* --- Init --- */
  watchVariantReRender();
  // Delay initial apply slightly to allow table to load if it's dynamic
  setTimeout(() => applyPrice(document), 500);

});